// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"address-book"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M20.5 2.5H6.5C4.84315 2.5 3.5 3.84315 3.5 5.5V18.5C3.5 16.8431 4.84315 15.5 6.5 15.5H20.5V2.5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M11 3H16V9L13.5 7.5L11 9V3Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M11 3H16V9L13.5 7.5L11 9V3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20.5 21.5H6.5C4.84315 21.5 3.5 20.1569 3.5 18.5C3.5 16.8431 4.84315 15.5 6.5 15.5H20.5V21.5ZM20.5 21.5V2.5H6.5C4.84315 2.5 3.5 3.84315 3.5 5.5V17.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const AddressBookIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'address-book',
    ref,
    icon: element,
  },
));

AddressBookIcon.displayName = 'AddressBookIcon';

export default AddressBookIcon;
